import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { type Capability, type Page, type Role } from 'src/types/directus/current-user'
import { type VerticalNavItemsType } from './@core/layouts/types'

export const navItemsAtom = atom<VerticalNavItemsType>([])

export const roleOptionsAtom = atom<Role[]>([])

export type CapabilityWithPage = Omit<Capability, 'page'> & {
  page: Page
}

export const capabilitiesAtom = atom<CapabilityWithPage[]>([])

const _selectedRoleAtom = atomWithStorage<Role | null>('selectedRole', null)

export const selectedRoleAtom = atom(
  get => {
    const roleOptions = get(roleOptionsAtom)
    const selectedRole = get(_selectedRoleAtom)

    // 🟢 Auto-select if only one option
    if (roleOptions.length === 1) {
      return roleOptions[0]
    }

    // 🟢 Auto-select first option if nothing is selected
    if (!selectedRole && roleOptions.length > 0) {
      return roleOptions[0]
    }

    // ❌ Reset if current selection is not valid
    if (selectedRole && !roleOptions.some(r => r.id === selectedRole.id)) {
      return null
    }

    return selectedRole
  },
  (_get, set, newRole: Role | null) => {
    if (newRole) {
      const roleOption = {
        ...newRole,
        label: newRole.name
      }
      set(_selectedRoleAtom, roleOption)
    } else {
      set(_selectedRoleAtom, null)
    }
  }
)

export const loadingAtom = atom(true)

export const currentModuleNameAtom = atom<string | null>(null)
